export default function getSearchKeywordSelector(state: Store): string {
    return state.search.keyword;
}
